import React from 'react';

import { P1 } from '../Title';


const CrawlerLatam = ({ data }) => {
  return (
  <>
    {data?.map((values, count) => (
      <>
      <P1 style={{ fontSize: '2rem', textAlign: 'center', padding: '1.6rem 1rem', lineHeight: '1.6rem', color: 'rgb(127, 133, 157)' }}> <strong>Inabilitação {count +1} </strong></P1>
      {Object.entries(values).map((subq, idnx) => (
        <P1 key={idnx} style={{ lineHeight: '1.6rem',padding: '1.6rem 1rem' }}>
          <strong>{subq[0]}</strong>
          :
          {' '}
          {subq[1]}
        </P1>
      ))}
      </>
    ))}
    
  </>)
}
;


export default CrawlerLatam;
